import { ScoutingCenter } from 'components/scoutingCenter/ScoutingCenter';

const ScoutingCenterSo5CompetitionPage = () => {
  return <ScoutingCenter />;
};

export default ScoutingCenterSo5CompetitionPage;
